import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Stakeholders by Impact and Influence',
      type: 'table',
      alias: 'stakeholder-impact-influence-matrix',
      content: {
        '{}': {
          count: 3,
          query: {
            '`': {
              selection: {
                '[]': [
                  {
                    '{}': {
                      fields: {
                        '{}': {
                          id: {
                            '{}': {
                              value: 'impact-high',
                            },
                          },
                          impact: {
                            '{}': {
                              value: 'High Impact',
                            },
                          },
                          rowTotal: {
                            '{}': {
                              value: {
                                '+': [
                                  {
                                    '??': [
                                      {
                                        '#': {
                                          '@': 'highImpactLowInfluence',
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                  {
                                    '??': [
                                      {
                                        '#': {
                                          '@': 'highImpactMediumInfluence',
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                  {
                                    '??': [
                                      {
                                        '#': {
                                          '@': 'highImpactHighInfluence',
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                ],
                              },
                            },
                          },
                          lowInfluence: {
                            '{}': {
                              color: '#FBC02D',
                              value: {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'highImpactLowInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          highInfluence: {
                            '{}': {
                              color: '#3AA69B',
                              value: {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'highImpactHighInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          mediumInfluence: {
                            '{}': {
                              color: '#7CB342',
                              value: {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'highImpactMediumInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      fields: {
                        '{}': {
                          id: {
                            '{}': {
                              value: 'impact-medium',
                            },
                          },
                          impact: {
                            '{}': {
                              value: 'Medium Impact',
                            },
                          },
                          rowTotal: {
                            '{}': {
                              value: {
                                '+': [
                                  {
                                    '??': [
                                      {
                                        '#': {
                                          '@': 'mediumImpactLowInfluence',
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                  {
                                    '??': [
                                      {
                                        '#': {
                                          '@': 'mediumImpactMediumInfluence',
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                  {
                                    '??': [
                                      {
                                        '#': {
                                          '@': 'mediumImpactHighInfluence',
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                ],
                              },
                            },
                          },
                          lowInfluence: {
                            '{}': {
                              color: '#EF6C00',
                              value: {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'mediumImpactLowInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          highInfluence: {
                            '{}': {
                              color: '#7CB342',
                              value: {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'mediumImpactHighInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          mediumInfluence: {
                            '{}': {
                              color: '#FBC02D',
                              value: {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'mediumImpactMediumInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      fields: {
                        '{}': {
                          id: {
                            '{}': {
                              value: 'impact-low',
                            },
                          },
                          impact: {
                            '{}': {
                              value: 'Low Impact',
                            },
                          },
                          rowTotal: {
                            '{}': {
                              value: {
                                '+': [
                                  {
                                    '??': [
                                      {
                                        '#': {
                                          '@': 'lowImpactLowInfluence',
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                  {
                                    '??': [
                                      {
                                        '#': {
                                          '@': 'lowImpactMediumInfluence',
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                  {
                                    '??': [
                                      {
                                        '#': {
                                          '@': 'lowImpactHighInfluence',
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                ],
                              },
                            },
                          },
                          lowInfluence: {
                            '{}': {
                              color: '#CD4643',
                              value: {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'lowImpactLowInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          highInfluence: {
                            '{}': {
                              color: '#FBC02D',
                              value: {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'lowImpactHighInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          mediumInfluence: {
                            '{}': {
                              color: '#EF6C00',
                              value: {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'lowImpactMediumInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                ],
              },
              subqueries: {
                lowImpactLowInfluence: {
                  filter: {
                    and: [
                      {
                        '=': [
                          {
                            '@.': '!degree_of_impact',
                          },
                          'Low',
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!influence_decision_role',
                          },
                          'Low',
                        ],
                      },
                    ],
                  },
                  target: 'ent:!stakeholders:!stakeholder',
                  selection: {
                    '@.': '!id',
                  },
                },
                highImpactLowInfluence: {
                  filter: {
                    and: [
                      {
                        '=': [
                          {
                            '@.': '!degree_of_impact',
                          },
                          'High',
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!influence_decision_role',
                          },
                          'Low',
                        ],
                      },
                    ],
                  },
                  target: 'ent:!stakeholders:!stakeholder',
                  selection: {
                    '@.': '!id',
                  },
                },
                lowImpactHighInfluence: {
                  filter: {
                    and: [
                      {
                        '=': [
                          {
                            '@.': '!degree_of_impact',
                          },
                          'Low',
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!influence_decision_role',
                          },
                          'High',
                        ],
                      },
                    ],
                  },
                  target: 'ent:!stakeholders:!stakeholder',
                  selection: {
                    '@.': '!id',
                  },
                },
                highImpactHighInfluence: {
                  filter: {
                    and: [
                      {
                        '=': [
                          {
                            '@.': '!degree_of_impact',
                          },
                          'High',
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!influence_decision_role',
                          },
                          'High',
                        ],
                      },
                    ],
                  },
                  target: 'ent:!stakeholders:!stakeholder',
                  selection: {
                    '@.': '!id',
                  },
                },
                lowImpactMediumInfluence: {
                  filter: {
                    and: [
                      {
                        '=': [
                          {
                            '@.': '!degree_of_impact',
                          },
                          'Low',
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!influence_decision_role',
                          },
                          'Medium',
                        ],
                      },
                    ],
                  },
                  target: 'ent:!stakeholders:!stakeholder',
                  selection: {
                    '@.': '!id',
                  },
                },
                mediumImpactLowInfluence: {
                  filter: {
                    and: [
                      {
                        '=': [
                          {
                            '@.': '!degree_of_impact',
                          },
                          'Medium',
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!influence_decision_role',
                          },
                          'Low',
                        ],
                      },
                    ],
                  },
                  target: 'ent:!stakeholders:!stakeholder',
                  selection: {
                    '@.': '!id',
                  },
                },
                highImpactMediumInfluence: {
                  filter: {
                    and: [
                      {
                        '=': [
                          {
                            '@.': '!degree_of_impact',
                          },
                          'High',
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!influence_decision_role',
                          },
                          'Medium',
                        ],
                      },
                    ],
                  },
                  target: 'ent:!stakeholders:!stakeholder',
                  selection: {
                    '@.': '!id',
                  },
                },
                mediumImpactHighInfluence: {
                  filter: {
                    and: [
                      {
                        '=': [
                          {
                            '@.': '!degree_of_impact',
                          },
                          'Medium',
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!influence_decision_role',
                          },
                          'High',
                        ],
                      },
                    ],
                  },
                  target: 'ent:!stakeholders:!stakeholder',
                  selection: {
                    '@.': '!id',
                  },
                },
                mediumImpactMediumInfluence: {
                  filter: {
                    and: [
                      {
                        '=': [
                          {
                            '@.': '!degree_of_impact',
                          },
                          'Medium',
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!influence_decision_role',
                          },
                          'Medium',
                        ],
                      },
                    ],
                  },
                  target: 'ent:!stakeholders:!stakeholder',
                  selection: {
                    '@.': '!id',
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'impact',
                  direct: {
                    '{}': {
                      name: 'Impact ↓ / Influence →',
                      type: 'TEXT',
                    },
                  },
                  isSortable: false,
                },
              },
              {
                '{}': {
                  id: 'lowInfluence',
                  direct: {
                    '{}': {
                      name: 'Low Influence',
                      type: 'INT',
                    },
                  },
                  isSortable: false,
                },
              },
              {
                '{}': {
                  id: 'mediumInfluence',
                  direct: {
                    '{}': {
                      name: 'Medium Influence',
                      type: 'INT',
                    },
                  },
                  isSortable: false,
                },
              },
              {
                '{}': {
                  id: 'highInfluence',
                  direct: {
                    '{}': {
                      name: 'High Influence',
                      type: 'INT',
                    },
                  },
                  isSortable: false,
                },
              },
              {
                '{}': {
                  id: 'rowTotal',
                  direct: {
                    '{}': {
                      name: 'Total',
                      type: 'INT',
                    },
                  },
                  isSortable: false,
                },
              },
            ],
          },
          totalRow: {
            '`': {
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      impact: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      rowTotal: {
                        '{}': {
                          value: {
                            '+': [
                              {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'highImpactLowInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                              {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'highImpactMediumInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                              {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'highImpactHighInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                              {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'mediumImpactLowInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                              {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'mediumImpactMediumInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                              {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'mediumImpactHighInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                              {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'lowImpactLowInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                              {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'lowImpactMediumInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                              {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'lowImpactHighInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                            ],
                          },
                        },
                      },
                      lowInfluence: {
                        '{}': {
                          value: {
                            '+': [
                              {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'highImpactLowInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                              {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'mediumImpactLowInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                              {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'lowImpactLowInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                            ],
                          },
                        },
                      },
                      highInfluence: {
                        '{}': {
                          value: {
                            '+': [
                              {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'highImpactHighInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                              {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'mediumImpactHighInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                              {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'lowImpactHighInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                            ],
                          },
                        },
                      },
                      mediumInfluence: {
                        '{}': {
                          value: {
                            '+': [
                              {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'highImpactMediumInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                              {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'mediumImpactMediumInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                              {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'lowImpactMediumInfluence',
                                    },
                                  },
                                  0,
                                ],
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                lowImpactLowInfluence: {
                  filter: {
                    and: [
                      {
                        '=': [
                          {
                            '@.': '!degree_of_impact',
                          },
                          'Low',
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!influence_decision_role',
                          },
                          'Low',
                        ],
                      },
                    ],
                  },
                  target: 'ent:!stakeholders:!stakeholder',
                  selection: {
                    '@.': '!id',
                  },
                },
                highImpactLowInfluence: {
                  filter: {
                    and: [
                      {
                        '=': [
                          {
                            '@.': '!degree_of_impact',
                          },
                          'High',
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!influence_decision_role',
                          },
                          'Low',
                        ],
                      },
                    ],
                  },
                  target: 'ent:!stakeholders:!stakeholder',
                  selection: {
                    '@.': '!id',
                  },
                },
                lowImpactHighInfluence: {
                  filter: {
                    and: [
                      {
                        '=': [
                          {
                            '@.': '!degree_of_impact',
                          },
                          'Low',
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!influence_decision_role',
                          },
                          'High',
                        ],
                      },
                    ],
                  },
                  target: 'ent:!stakeholders:!stakeholder',
                  selection: {
                    '@.': '!id',
                  },
                },
                highImpactHighInfluence: {
                  filter: {
                    and: [
                      {
                        '=': [
                          {
                            '@.': '!degree_of_impact',
                          },
                          'High',
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!influence_decision_role',
                          },
                          'High',
                        ],
                      },
                    ],
                  },
                  target: 'ent:!stakeholders:!stakeholder',
                  selection: {
                    '@.': '!id',
                  },
                },
                lowImpactMediumInfluence: {
                  filter: {
                    and: [
                      {
                        '=': [
                          {
                            '@.': '!degree_of_impact',
                          },
                          'Low',
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!influence_decision_role',
                          },
                          'Medium',
                        ],
                      },
                    ],
                  },
                  target: 'ent:!stakeholders:!stakeholder',
                  selection: {
                    '@.': '!id',
                  },
                },
                mediumImpactLowInfluence: {
                  filter: {
                    and: [
                      {
                        '=': [
                          {
                            '@.': '!degree_of_impact',
                          },
                          'Medium',
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!influence_decision_role',
                          },
                          'Low',
                        ],
                      },
                    ],
                  },
                  target: 'ent:!stakeholders:!stakeholder',
                  selection: {
                    '@.': '!id',
                  },
                },
                highImpactMediumInfluence: {
                  filter: {
                    and: [
                      {
                        '=': [
                          {
                            '@.': '!degree_of_impact',
                          },
                          'High',
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!influence_decision_role',
                          },
                          'Medium',
                        ],
                      },
                    ],
                  },
                  target: 'ent:!stakeholders:!stakeholder',
                  selection: {
                    '@.': '!id',
                  },
                },
                mediumImpactHighInfluence: {
                  filter: {
                    and: [
                      {
                        '=': [
                          {
                            '@.': '!degree_of_impact',
                          },
                          'Medium',
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!influence_decision_role',
                          },
                          'High',
                        ],
                      },
                    ],
                  },
                  target: 'ent:!stakeholders:!stakeholder',
                  selection: {
                    '@.': '!id',
                  },
                },
                mediumImpactMediumInfluence: {
                  filter: {
                    and: [
                      {
                        '=': [
                          {
                            '@.': '!degree_of_impact',
                          },
                          'Medium',
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!influence_decision_role',
                          },
                          'Medium',
                        ],
                      },
                    ],
                  },
                  target: 'ent:!stakeholders:!stakeholder',
                  selection: {
                    '@.': '!id',
                  },
                },
              },
            },
          },
        },
      },
    },
  },
}
